<div class="spinner-value" [ngStyle]="{'fontSize': this.fontSize}" *ngIf="displayWith">{{displayWith(valueText)}}</div>
<div class="spinner-background"></div>
<mat-progress-spinner [color]="color" [diameter]="diameter" mode="determinate" [strokeWidth]="strokeWidth"
    [value]="value">
</mat-progress-spinner>
